import useCounter from 'react-use/lib/useCounter';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';
export default function useCounterIncrementingWhen(condition, onIncrement) {
    const [counter, { inc }] = useCounter(0);
    // useUpdateEffect does not run on mount
    // https://github.com/streamich/react-use/blob/master/docs/useUpdateEffect.md
    useUpdateEffect(() => {
        if (condition) {
            inc();
            onIncrement === null || onIncrement === void 0 ? void 0 : onIncrement();
        }
    }, [inc, condition, onIncrement]);
    return counter;
}
//# sourceMappingURL=useCounterIncrementingWhen.js.map